import { IResponseAPI } from "../entities/IResponseAPI";
import { IAddUsuarioExterno, IUsuarioExterno } from "../entities/IUsuarioExterno";
import { deleteAPI, getAPI, postAPI } from "../helpers/httpHelper";
import { API_ADMIN_USER, API_MODULOS, API_ROLES, API_ROLES_USERS, API_USERS, URL_SUPPORT } from "../helpers/variableHelper";
import { IRolesAsignados, IRolesUsuario, ISearchAllRolesUsuario, ISearchRolesUsuario } from "../entities/IRolesUsuario";
import { IModulos, ISearchModulos } from "../entities/IModulo";
import { IRoles } from "../entities/IRoles";

export class UsuariosExternosServices {
  constructor() {
    console.log("");
  }

  public static async getListUsuariosExternos(token: string, filter: any): Promise<IResponseAPI<Array<IUsuarioExterno>>> {
    try {
      let result = await getAPI(`${URL_SUPPORT}${API_USERS}/GetUsersExternal`, { Authorization: `Bearer ${token}` }, filter);
      return result.result;
    } catch (e) {
      return {} as IResponseAPI<Array<IUsuarioExterno>>;
    }
  }

  public static async setUsuarioExterno(token: string, value: IAddUsuarioExterno): Promise<IResponseAPI<number>> {
    let result: any = null;

    try {
      result = await postAPI(`${URL_SUPPORT}${API_USERS}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result;
    } catch (error: any) {
      result = error.response.data;
      return result;
    }
  }

  public static async getAllRolesUsuario(token: string, params: ISearchAllRolesUsuario): Promise<IResponseAPI<Array<IRolesUsuario>>> {
    try {
      let result = await getAPI(`${URL_SUPPORT}${API_ROLES_USERS}/getall`, { Authorization: `Bearer ${token}` }, params);
      return result.result;
    } catch (e) {
      return {} as IResponseAPI<Array<IRolesUsuario>>;
    }
  }

  public static async getAllModulos(token: string, params: ISearchModulos): Promise<IResponseAPI<Array<IModulos>>> {
    try {
      let result = await getAPI(`${URL_SUPPORT}${API_MODULOS}/getall`, { Authorization: `Bearer ${token}` }, params);
      return result.result;
    } catch (e) {
      return {} as IResponseAPI<Array<IModulos>>;
    }
  }

  public static async getAllRoles(token: string, params: any): Promise<IResponseAPI<Array<IRoles>>> {
    try {
      let result = await getAPI(`${URL_SUPPORT}${API_ROLES}/getall`, { Authorization: `Bearer ${token}` }, params);
      return result.result;
    } catch (e) {
      return {} as IResponseAPI<Array<IRoles>>;
    }
  }

  public static async setRolUsuario(token: string, value: any): Promise<IResponseAPI<number>> {
    let result: any = null;
    try {
      result = await postAPI(`${URL_SUPPORT}${API_ROLES_USERS}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result;
    } catch (error: any) {
      result = error.response.data;
      return result;
    }
  }

  public static async deleteRolesUsuario(token: string, email: any): Promise<IResponseAPI<number>> {
    try {
      let result = (
        await deleteAPI(
          `${URL_SUPPORT}${API_ROLES_USERS}/DeleteRolesUsuario`,
          { Authorization: `Bearer ${token}` },
          {
            EMAIL: email,
          }
        )
      ).result;

      return result.data;
    } catch (e) {
      return {} as IResponseAPI<number>;
    }
  }

  public static async isUsuarioExterno(token: string, email: string) {
    try {
      let resultDB = await getAPI(`${URL_SUPPORT}${API_ADMIN_USER}/GetUsersInternal/${email}`, { Authorization: `Bearer ${token}` });

      return resultDB.result?.length > 0;
    } catch (e) {
      return false;
    }
  }

  public static async getRolesUsuario(token: string, params: ISearchRolesUsuario): Promise<IResponseAPI<Array<IRolesUsuario>>> {
    try {
      let result = await getAPI(`${URL_SUPPORT}${API_ROLES_USERS}/GetRolesUsuario`, { Authorization: `Bearer ${token}` }, params);
      return result.result;
    } catch (e) {
      return {} as IResponseAPI<Array<IRolesUsuario>>;
    }
  }

  public static async checkRolesAsignados(token: string, params: ISearchRolesUsuario) {
    let rolesUsuario: IRolesAsignados = {
      IS_ADMIN: false,
      IS_ADMIN_AUDITORIA: false,
      IS_ADMIN_PROVEEDORES: false,
    };
    try {
      let roles = (await this.getRolesUsuario(token, params)).data;
      roles.forEach((rol) => {
        if (rol.IS_ADMIN || rol.ID === 49) {
          rolesUsuario.IS_ADMIN = true;
        } else if (rol.ROL === "Responsable de programa Auditoria" || rol.ID === 46) {
          rolesUsuario.IS_ADMIN_AUDITORIA = true;
        } else if (rol.ROL === "Responsable programa provedores" || rol.ID === 47) {
          rolesUsuario.IS_ADMIN_PROVEEDORES = true;
        } else if (rol.ROL === "Contratistas LIO" || rol.ID === 45) {
          rolesUsuario.IS_EXT_LIO = true;
        } else if (rol.ROL === "Contratistas Proveedores" || rol.ID === 48) {
          rolesUsuario.IS_EXT_PROVEEDORES = true;
        }
      });
    } catch (e) {
      console.log(e);
    }
    return rolesUsuario;
  }
}
